export const EVENTS = {
  sortSelected: 'sort:selected',
  variantChange: 'variant:change',
  ajaxCollectionRender: 'ajaxCollection:render',
  ajaxProductError: 'ajaxProduct:error',
  ajaxProductAdded: 'ajaxProduct:added',
  mobileNavOpen: 'mobileNav:open',
  mobileNavClose: 'mobileNav:close',
  desktopNavOpen: 'desktopNav:open',
  desktopNavClose: 'desktopNav:close',
  predictiveSearchOpen: 'predictiveSearch:open',
  predictiveSearchClose: 'predictiveSearch:close',
  predictiveSearchCloseAll: 'predictiveSearch:close-all',
  headerStickyCheck: 'headerSticky:check',
  stickyHeaderChange: 'stickyHeaderChange',
  overlayHeaderChange: 'overlayHeader:change',
  headerOverlayDisable: 'headerOverlay:disable',
  headerOverlayRemoveClass: 'headerOverlay:remove-class',
  cartDrawerChange: 'CartDrawer:change',
  youtubeReady: 'youtube:ready',
  vimeoReady: 'vimeo:ready',
  cartOpen: 'cart:open',
  cartClose: 'cart:close',
  sizeDrawer: 'size:drawer',
  cartUpdated: 'cart:updated',
  headerDrawerOpened: 'headerDrawer:opened',
  headerDrawerClosed: 'headerDrawer:closed',
  headerSearchOpen: 'headerSearch:open',
  headerSearchClose: 'headerSearch:close',
  toggleMobileFilters: 'toggleMobileFilters',
  viewChange: 'viewChange',
  // Dispatched on window by Klaviyo's onsite script, not by the theme (DEC-220).
  klaviyoForms: 'klaviyoForms'
}
